import ArrowCircleIcon from './arrow-circle.svg?react'
import CrossIcon from './close.svg?react'
import DeleteSquareIcon from './delete-square.svg?react'
import FoldIcon from './fold.svg?react'
import FreezeIcon from './freeze.svg?react'
import LoadingIcon from './loading.svg?react'
import SearchEmptyIcon from './no-search-results.svg?react'
import UnfoldIcon from './unfold.svg?react'

export const ArrowCircle = ArrowCircleIcon
export const Cross = CrossIcon
export const DeleteSquare = DeleteSquareIcon
export const Fold = FoldIcon
export const Freeze = FreezeIcon
export const SearchEmpty = SearchEmptyIcon
export const Unfold = UnfoldIcon
export const Loading = LoadingIcon
